<template>
  <div id="app">
    <router-view :users="users" :message="message" />
  </div>
</template>

<script>
export default {
  name: 'app',
  data: () => ({
    users: [],
    message: {},
    notifyPromise: Promise.resolve()
  }),
  computed: {
    
  },
  watch: {
    "message.notification": function(val, old) {
      //show notification
      //console.log(val)
      //console.log(old)
      let notice = this.message.notification,
          that = this
      notice.forEach(function(v) {
        //console.log(v)
        if (v.flag == 0) {
          that.$notify({
            title: v.title,
            message: v.content,
            position: 'bottom-right',
            type: 'warning',
            duration: 0
          })
        }
      })
    }
  },
  methods: {
    getMessages: function() {
      let that = this,
          query = '?user=' + localStorage.getItem('token')
      this.$http.get(this.API_PREFIX + 'messages' + query).then(function (response) {
        that.message = response.data
        //that.$store.commit('setVersion', that.message.version)
        if (that.message.version != that.VERSION) {
          that.$message({
            showClose: true,
            duration: 0,
            message: that.$t('nav.notification.update', { ver: that.message.version }),
            type: 'warning'
          })
        }
        let interval = window.setTimeout(that.getMessages, 60000)
      }).catch(function (error) {
        if(error.response) {
          switch(error.response.status) {
            case 401:
              //login
              that.$router.push({ path: '/login' })
              break
          }
        }
        console.log(error)
      })
    },
    loadUser: function() {
      let that = this,
          query = '?results_per_page=100000&q='
      this.$http.get(this.API_PREFIX + 'user_list' + query).then(function (response) {
        that.users = response.data
      }).catch(function (error) {
        console.log(error)
      })
    },
    onBrowserBack() {
      
    }
  },
  mounted: function() {
    this.loadUser()
    this.getMessages()
    window.addEventListener('hashchange',()=>{
      if (window.location.hash) {
        var currentPath = window.location.hash.slice(1);
        console.log('变更:', currentPath)
        if(this.$router.path !== currentPath && currentPath){
          this.$router.push(currentPath);
        }
      }
    },false);
  },
  destroyed() {
    // 当页面销毁必须要移除这个事件，vue不刷新页面，不移除会重复执行这个事件
    //window.removeEventListener("popstate", this.onBrowserBack, false);
  }
}
</script>